<template>
  <v-data-table
    v-if="quoteItems"
    :no-data-text="$t('table.noResults')"
    :headers="quoteHeaders"
    :loading="isLoading"
    :items="quoteItems"
    :items-per-page="1000"
    mobile-breakpoint="20"
    item-key="id"
    hide-default-footer
    disable-sort
  >
    <template v-slot:item.item_name="{ item }">
      <span :class="isNotAccepted(item)" class="d-block text-truncate">
        {{ item && tableItem(item.item_name) }}
      </span>
    </template>
    <template v-slot:item.item_category_name="{ item }">
      <span :class="isNotAccepted(item)" class="d-block text-truncate">
        {{ item && tableItem(item.item_category_name) }}
      </span>
    </template>
    <template v-slot:item.service_report_item_quantity="{ item }">
      <span :class="isNotAccepted(item)" class="d-block">
        {{ item && tableItem(item.service_report_item_quantity) }}
      </span>
    </template>
    <template v-slot:item.calculated_price="{ item }">
      <span :class="isNotAccepted(item)">
        {{ itemPrice(item) }}
      </span>
    </template>
    <template v-slot:item.accepted="{ item }">
      <div v-if="item">
        <div v-if="isRealEstateRole">
          <div v-if="item.id !== '1'">
            <span v-if="isQuoteAlreadyPaid || isQuotePending">
              {{ $t(`quote.label.${item.accepted ? 'accepted' : 'notAccepted'}`) }}
            </span>
            <div v-else class="d-flex justify-end">
              <v-switch
                v-model="item.accepted"
                v-if="appointment.type !== 'DUMP'"
                @change="handleAcceptedItems(item)"
                :disabled="itemSwitchDisabled(item)"
                :loading="isLoadingAcceptation"
                hide-details="auto"
                class="mr-n4"
                dense
                inset
              />
              <span v-else>
                {{
                  $t(`quote.label.${item.accepted ? 'accepted' : 'notAccepted'}`)
                }}
              </span>
            </div>
          </div>
          <div v-else class="mr-3">---</div>
        </div>
        <div v-else>
          {{ $t(`quote.label.${item.accepted ? 'accepted' : 'notAccepted'}`) }}
        </div>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { catalogMonetary } from '@/util/catalog'
import { quoteTableHeaders } from '@/views/listHeaders/serviceReportHeaders'
import { rentOutTypes } from '@/components/appointment/formFieldsCreate/appointmentFormDefaults'

export default {
  name: 'QuoteItemsList',

  props: {
    isQuoteAlreadyPaid: {
      type: Boolean,
    },

    isQuotePending: {
      type: Boolean,
    },

    quoteItems: {
      type: Array,
    },

    quote: {
      type: Object,
    },

    appointment: {
      type: Object,
    },

    version: {
      type: Number | String,
      default: 1,
    }
  },

  watch: {
    quoteItems(newValue) {
      this.acceptedItems = newValue
        ?.filter((item) => item.accepted)
        .map((item) => item.id)
    },
  },

  computed: {
    ...mapGetters(['isLoading']),

    isRealEstateRole() {
      return localStorage.getItem('access_roles').includes('ROLE_REAL_ESTATE')
    },

    acceptedItemsChanged() {
      return (
        JSON.stringify(
          this.quoteItems.filter((item) => item.accepted).sort()
        ) != JSON.stringify(this.acceptedItems.sort())
      )
    },
  },

  methods: {
    ...mapActions(['acceptQuoteItems']),

    isNotAccepted(item) {
      if (!item) return
      return !item?.accepted ? 'text-decoration-line-through' : ''
    },

    itemPrice(item) {
      if (!item) return
      switch(this.appointment.type) {
        case rentOutTypes.includes(this.appointment.type):
          if (this.version == 2) return item.calculated_price ? this.formatMoney(item.calculated_price) : ''
          else return item?.calculated_by_installment_price ? this.formatMoney(item.calculated_by_installment_price) : ''
        case 'EVICTION':
          return item?.calculated_price ? this.formatMoney(item.calculated_price) : ''
        default:
          return item?.calculated_price ? this.formatMoney(item.calculated_price) : ''
      }
    },

    handleAcceptedItems(item) {
      this.isLoadingAcceptation = true
      this.acceptItem(item)
    },

    itemSwitchDisabled(item) {
      const isLoading = this.isLoadingAcceptation
      const acceptedLength = this.acceptedItems.length
      const isAcceptedAndHasLength = item.accepted && acceptedLength <= 1

      if (isLoading || isAcceptedAndHasLength) return true
      return false
    },

    acceptItem(item) {
      if (this.acceptedItems?.length && this.acceptedItemsChanged) {
        if (item.accepted) {
          this.acceptedItems.push(item.id)
        } else {
          this.acceptedItems = this.acceptedItems.filter(
            (toRemove) => toRemove != item.id
          )
        }

        var body = {
          quote_id: this.quote?.id,
          quote_items_to_accept: this.acceptedItems,
          appointment_id: this.appointment.id,
        }

        this.acceptQuoteItems(body).finally(() => {
          this.isLoadingAcceptation = false
        })
      }
    },

    tableItem(value) {
      if (!value) return '---'
      return value
    },
  },

  data() {
    return {
      quoteHeaders: quoteTableHeaders,
      formatMoney: catalogMonetary,
      isLoadingAcceptation: false,
      acceptedItems: [],
    }
  },

  mounted() {
    if (this.quoteItems.length) this.acceptedItems = this.quoteItems
      ?.filter((item) => item?.accepted)
      .map((item) => item.id)
  },
}
</script>
